import { render, staticRenderFns } from "./occasion-card.vue?vue&type=template&id=7c15e72e"
import script from "./occasion-card.vue?vue&type=script&lang=ts"
export * from "./occasion-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/vercel/path0/components/ui/button.vue').default})
